export const FREQUENCY = {
  // barchart ticker frequency
  0: 'None',
  1: 'Annual',
  2: 'Semi-Annual',
  4: 'Quarterly',
  5: 'Monthly',
  7: 'TBD',
  8: 'Variable',
  9: 'Not Available',
};
